import React, { useState } from "react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";

const FollowingImageAlbum: React.FC<{ post: any }> = ({ post }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <div className="flex h-full w-full items-center relative rounded-lg overflow-hidden">
      {/* Background Blur */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-black opacity-50 blur-3xl"
        style={{
          backgroundImage: `url("${post?.post_attachments[0].attachment_thumbnail_image_file_src}")`,
        }}
      />

      <Carousel
        plugins={[
          Autoplay({
            delay: 5000,
          }),
        ]}
        className="flex w-full h-full items-center"
        onSlideChange={(index: number) => setCurrentIndex(index)}
      >
        <CarouselContent className="">
          {post?.post_attachments.map((att: any, index: number) => (
            <CarouselItem key={index}>
              <div className="flex w-full h-full relative ">
                <img
                  src={att.attachment_media_image_file_src}
                  alt="Post"
                  className="relative z-10  w-full h-auto  object-contain"
                  loading="lazy"
                />
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>

      {/* Page Indicator */}
      <div className="absolute top-4 right-4 text-white bg-black/60 px-3 py-1 rounded text-sm z-20">
        {currentIndex + 1} / {post?.post_attachments.length}
      </div>
    </div>
  );
};

export default FollowingImageAlbum;

